var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Play = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.53695154,6.80664662 L16.4486242,11.1221044 C16.9334725,11.3865672 17.1121304,11.9940038 16.8476676,12.4788521 C16.7557223,12.6474186 16.6171907,12.7859502 16.4486242,12.8778956 L8.53695154,17.1933534 C8.0521032,17.4578161 7.44466657,17.2791583 7.18020384,16.7943099 C7.10008278,16.6474213 7.05809941,16.4827768 7.05809941,16.3154578 L7.05809941,7.68454219 C7.05809941,7.13225744 7.50581466,6.68454219 8.05809941,6.68454219 C8.2254184,6.68454219 8.39006294,6.72652556 8.53695154,6.80664662 Z M8.05809941,7.75 L8.05809941,16.25 L16.0580994,12 L8.05809941,7.75 Z" })));
};
Play.displayName = 'Play';
export default Play;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Play.js.map